import React from "react";
const Error = () => {
  return (
    <section className='section'>
      <h2>About</h2>
    </section>
  );
};
export default Error;
